import {createFileRoute} from '@tanstack/react-router';

import RecoverPassword from '@/anonymous/views/RecoverPassword';

export const Route = createFileRoute('/(anonymous)/recover-password')({
  component: RecoverPassword
});
